/* eslint-disable prettier/prettier */

export const withdrawConstants = {
  WITHDRAW_HISTORY_API_SUCCESS: 'WITHDRAW_HISTORY_API_SUCCESS',
  WITHDRAW_HISTORY_API_FAILED: 'WITHDRAW_HISTORY_API_FAILED',
  WITHDRAW_CREATE_SUCCESS: 'WITHDRAW_CREATE_SUCCESS',
  WITHDRAW_CREATE_FAILED: 'WITHDRAW_CREATE_FAILED',
}
